import React from 'react';
import {connect} from "react-redux";
import {Alert, Form, Icon, Input, Button, Row, Col, Select} from 'antd';
import get from 'lodash/get';
import find from 'lodash/find';
import isAuthenticated from "../../utils/isAuthenticated";
import { updateAccountInfoRequest } from '../../api/requests';
import {
  getProfileUpdateTimezonePermission,
} from "../../reducers/user/selectors";

import classes from './MyProfileForm.css';
import { withNamespaces } from 'react-i18next';

const timezones = require('../../utils/timezones.json');

const { Option } = Select;
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class MyProfileForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      shortTz: get(find(timezones, ({ utc }) => utc.includes(this.props.time_zone)), 'abbr', ''),
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const profile = {...values};
          // profile.short_tz = timeZones[profile.time_zone];
          if (profile.time_zone === "") {
            profile.time_zone = null;
          }

          if (!profile.phone_number) {
            delete profile['phone_number']
          }

          await updateAccountInfoRequest(profile);
          this.setState({ isLoading: false, requestResult: {type: 'success', message: this.props.i18n.t('Success') } });
          this.props.onSubmit();
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '');
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };


  render() {
    const { isLoading, requestResult, shortTz } = this.state;
    const { getFieldDecorator } = this.props.form;

        return (
          <div className={classes.wrapper}>
              <Form onSubmit={this.handleSubmit}>
                <h3 className='headline-default'>{this.props.i18n.t('NamespaceMyProfileForm:Edit profile')}</h3>

                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>{this.props.i18n.t('Email')}</b>
                      <Form.Item>
                        {getFieldDecorator('email', {
                          rules: [{ required: true, message: this.props.i18n.t('Required') }],
                          initialValue: get(this.props, 'email')
                        })( <Input type='email' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                    <label>
                      <b>{this.props.i18n.t('First name')}</b>
                      <Form.Item>
                        {getFieldDecorator('first_name', {
                          rules: [{ required: true, message: this.props.i18n.t('Required') }],
                          initialValue: get(this.props, 'first_name')
                        })( <Input type='text' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                    <label>
                      <b>{this.props.i18n.t('Last name')}</b>
                      <Form.Item>
                        {getFieldDecorator('last_name', {
                          rules: [{ required: true, message: this.props.i18n.t('Required') }],
                          initialValue: get(this.props, 'last_name')
                        })( <Input type='text' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                    <label>
                      <b>{this.props.i18n.t('Phone number')}</b>
                      <Form.Item>
                        {getFieldDecorator('phone_number', {
                          initialValue: get(this.props, 'phone_number')
                        })( <Input type='phone' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                  <label>
                    <b>{this.props.i18n.t('Time Zone')}:</b>
                    <Form.Item>
                      {getFieldDecorator('time_zone', {
                        initialValue: get(this.props, 'time_zone', '')
                      })(
                        <Select disabled={!this.props.profileUpdateTimezonePermission} showSearch placeholder={this.props.i18n.t('Select')} onChange={this.onChangeTimezone}>
                          <Option value="">{this.props.i18n.t('None')}</Option>
                          {timezones.map(({ utc }) => utc.map((tz, i) => (
                            <Option value={tz} key={i}>{tz}</Option>
                          )))}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                  </Col>
                  <Col>
                  <label>
                      <b>{this.props.i18n.t('NamespaceMyProfileForm:Short TZ')}</b>
                      <Form.Item>
                        {getFieldDecorator('short_tz', {
                          initialValue: shortTz
                        })( <Input disabled={true} type='text' /> )}
                      </Form.Item>
                    </label>
                 </Col>
                 <Col>
                  <label>
                    <b>{this.props.i18n.t('Language')}:</b>
                    <Form.Item>
                      {getFieldDecorator('language', {
                        initialValue: get(this.props, 'language', '')
                      })(
                        <Select>
                          {this.props.languages.map(language => 
                            <Select.Option key={language.id} value={language.id}>{language.name}</Select.Option>
                          )}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                  </Col>
                  <Col>
                    <label>
                      <b>{this.props.i18n.t('NamespaceMyProfileForm:Type your password to confirm the changes')}</b>
                      <Form.Item>
                        {getFieldDecorator('password', {
                          rules: [{ required: true, message: this.props.i18n.t('Required') }],
                          initialValue: get(this.props, 'password')
                        })( <Input type='password' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>

                {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

                <Form.Item className={classes.actionWrapper}>
                  <Button type='primary' size='large' htmlType='submit'>
                    {this.props.i18n.t('Save')}
                    {isLoading && <Icon type='loading' />}
                  </Button>

                  <Button type='default' size='large' htmlType='button' onClick={this.props.onCancel}>
                    {this.props.i18n.t('Cancel')}
                  </Button>
                </Form.Item>
              </Form>
          </div>
      );
    }
}
const mapStateToProps = (state) => ({
  profileUpdateTimezonePermission: getProfileUpdateTimezonePermission(
    state
  ),
});

export default isAuthenticated(
  Form.create({ name: "myProfileForm" })(
    connect(mapStateToProps)(withNamespaces()(MyProfileForm))
  )
);



// WEBPACK FOOTER //
// ./src/components/MyProfileForm/MyProfileForm.js